import React from 'react';
import { ProfileAvatarUpload } from '../../profile/ProfileAvatarUpload';
import { useAuth } from '../../../context/auth';
import { useProfileStore } from '../../../stores/profileStore';

interface ProfileImageSectionProps {
  className?: string;
}

export const ProfileImageSection: React.FC<ProfileImageSectionProps> = ({ className = '' }) => {
  const { user } = useAuth();
  const { profile } = useProfileStore();

  return (
    <div
      className={`flex flex-col items-center justify-center bg-[#E1E9F0] w-full h-[19.5625rem] mb-4 overflow-hidden ${className}`}
    >
      {user && (
        <div className="w-full h-full flex items-center justify-center p-4">
          <ProfileAvatarUpload
            profileId={user.id}
            imageUrl={profile?.avatar_url}
            size={96}
            design="form"
            className="object-contain"
          />
        </div>
      )}
    </div>
  );
};
